import {
  IQuoteDocumentTag,
  IQuoteDocumentTagData,
  IQuoteProductDocumentData,
  QuoteDocumentTag
} from '@/models';
import { Document, DocumentRevision } from '../document';
import {
  IDocument,
  IDocumentData,
  IDocumentRevision,
  IDocumentRevisionData
} from '../document.types';
import { IQuoteProductDocumentPaginatedListData } from '@/services/document';

export const mockQuoteDocumentTagsData = (): IQuoteDocumentTagData[] => [
  {
    id: 1,
    tag: {
      id: 4,
      label: 'Test Tag 1'
    }
  },
  {
    id: 2,
    tag: {
      id: 5,
      label: 'Test Tag 2'
    }
  },
  {
    id: 3,
    tag: {
      id: 6,
      label: 'Test Tag 3'
    }
  }
];

export const mockDocumentRevisionsData = (): IDocumentRevisionData[] => [
  {
    id: 2,
    owner: 'Test User',
    revision: 2,
    uploaded_at: '2024-07-17T20:48:26.213979Z',
    file: 'documents/1/Screenshot_2023-03-02_164558.png'
  },
  {
    id: 1,
    owner: 'Test User',
    revision: 1,
    uploaded_at: '2024-07-17T20:05:57.509673Z',
    file: 'documents/1/Screenshot_2024-07-16_154212.png'
  }
];

export const mockQuoteProductDocumentsData = (): IQuoteProductDocumentData[] => [
  {
    id: 1,
    quote_document: {
      id: 1,
      document: {
        id: 2,
        title: 'test',
        description: 'slfkdjbn',
        created_at: '2024-08-28T17:27:19.237940Z',
        latest_revision: mockDocumentRevisionsData()[0],
        tags: []
      }
    }
  }
];

export const mockQuoteDocumentTags = (
  data: IQuoteDocumentTagData[] = mockQuoteDocumentTagsData()
): IQuoteDocumentTag[] => data.map(item => new QuoteDocumentTag(item));

export const mockQuoteProductDocuments = (
  data: IDocumentData[] = mockQuoteProductDocumentsData()
): IDocument[] => data.map(item => new Document(item));

export const mockDocumentRevisions = (
  data: IDocumentRevisionData[] = mockDocumentRevisionsData()
): IDocumentRevision[] => data.map(item => new DocumentRevision(item));

export const mockQuoteProductDocumentPaginatedData = (): IQuoteProductDocumentPaginatedListData => {
  return {
    count: mockQuoteDocumentTagsData().length,
    next: '',
    previous: '',
    results: mockQuoteProductDocumentsData()
  };
};
